module.exports = __webpack_public_path__ + "static/media/appstore-dw-icon.4737faf3.png";